const Address = require('./Address');
const Center = require('./Center');

class Provider {
  constructor() {
    this.init();
  }

  init() {
    this.provider_id = undefined;
    this.is_active_mrr = undefined;
    this.name = '';
    this.email = '';
    this.contact = undefined;
    this.phone_number = undefined;
    this.external_link = undefined;
    this.handbook_url = undefined;
    this.safety_guidelines_url = undefined;
    this.logo_url = undefined;
    this.address = new Address();
    this.contracts = undefined;
    this.onboarding_call_scheduled = undefined;
    this.kinside_onboarded = false;
    this.kinside_id = undefined;
    this.kinside_fees = undefined;

    // Read-only properties
    this.centers = [];
  }

  copy() {
    const cp = new Provider();

    cp.provider_id = this.provider_id;
    cp.is_active_mrr = this.is_active_mrr;
    cp.name = this.name;
    cp.email = this.email;
    cp.contact = this.contact;
    cp.phone_number = this.phone_number;
    cp.address = this.address;
    cp.external_link = this.external_link;
    cp.handbook_url = this.handbook_url;
    cp.safety_guidelines_url = this.safety_guidelines_url;
    cp.logo_url = this.logo_url;
    cp.onboarding_call_scheduled = this.onboarding_call_scheduled;
    cp.kinside_onboarded = this.kinside_onboarded;
    cp.kinside_id = this.kinside_id;
    cp.kinside_fees = this.kinside_fees;

    cp.centers = [];
    this.centers.forEach((c) => {
      cp.centers.push(c.copy());
    })
    if (this.contracts) {
      cp.contracts = [];
      this.contracts.forEach((c) => {
        cp.contracts.push(c.copy());
      });
    }
    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.provider_id = obj.provider_id ? obj.provider_id.toString() : undefined;
      this.is_active_mrr = obj.is_active_mrr;
      this.name = obj.name ? obj.name : '';
      this.email = obj.email? obj.email: '';
      this.contact = obj.contact ? obj.contact : undefined;
      this.phone_number = obj.phone_number ? obj.phone_number : undefined;
      this.external_link = obj.external_link ? obj.external_link : undefined;
      this.handbook_url = obj.handbook_url ? obj.handbook_url : undefined;
      this.safety_guidelines_url = obj.safety_guidelines_url ? obj.safety_guidelines_url : undefined;
      this.onboarding_call_scheduled = obj.onboarding_call_scheduled ? obj.onboarding_call_scheduled : undefined;
      this.kinside_onboarded = obj.kinside_onboarded ? obj.kinside_onboarded : false;
      this.logo_url = obj.logo_url ? obj.logo_url : undefined;
      this.address.buildFromJSON(obj.address ? obj.address : {});
      this.kinside_id = obj.kinside_id ? obj.kinside_id : undefined;
      this.kinside_fees = obj.kinside_fees ? obj.kinside_fees : undefined;
      this.centers = [];
      if (obj.centers) {
        obj.centers.forEach((c) => {
          const ctr = new Center();
          ctr.buildFromJSON(c);
          this.centers.push(ctr);
        });
      }
      if (obj.contracts) {
        this.contracts = [];
        obj.contracts.forEach((c) => {
          const contract = new Contract();
          contract.buildFromJSON(c);
          this.contracts.push(contract);
        });
      }
    }
  }

  toString() {
    let result = this.name;
    let email = this.email;
    const address = this.address.toString();

    if (this.provider_id) {
      result = (result.length) ? `${result} (${this.provider_id})` : `${this.provider_id}`;
    }
    if (address.length) {
      result = (result.length) ? `${result}: ${address}` : address;
    }

    return result;
  }

  getId() {
    return this.provider_id;
  }

  setId(provider_id) {
    this.provider_id = provider_id ? provider_id.toString() : undefined;
  }

  getName() {
    return this.name;
  }

  setName(name) {
    this.name = name;
  }

  getEmail() {
    return this.email;
  }

  setEmail(email) {
    this.email = email;
  }

  getContact() {
    return this.contact;
  }

  setContact(contact) {
    this.contact = contact;
  }

  getPhoneNumber() {
    return this.phone_number;
  }

  setPhoneNumber(phone_number) {
    this.phone_number = phone_number;
  }

  getExternalLink() {
    return this.external_link;
  }

  setExternalLink(external_link) {
    this.external_link = external_link;
  }

  getHandbookUrl() {
    return this.handbook_url;
  }

  setHandbookUrl(handbook_url) {
    this.handbook_url = handbook_url;
  }

  getSafetyGuidelinesUrl() {
    return this.safety_guidelines_url;
  }

  setSafetyGuidelinesUrl(safety_guidelines_url) {
    this.safety_guidelines_url = safety_guidelines_url;
  }

  getOnboardingCallScheduled() {
    return this.onboarding_call_scheduled;
  }

  setOnboardingCallScheduled(onboarding_call_scheduled) {
    this.onboarding_call_scheduled = onboarding_call_scheduled;
  }

  getKinsideOnboarded() {
    return this.kinside_onboarded;
  }

  setKinsideOnboarded(kinside_onboarded) {
    this.kinside_onboarded = kinside_onboarded;
  }

  getLogoUrl() {
    return this.logo_url;
  }

  setLogoUrl(logo_url) {
    this.logo_url = logo_url;
  }

  getAddress() {
    return this.address;
  }

  setAddress(address) {
    this.address = address;
  }

  getIsActiveMrr() {
    return this.is_active_mrr;
  }

  setIsActiveMrr(isActiveMrr) {
    this.is_active_mrr = isActiveMrr;
  }

  getContracts(include_private = false) {
    return include_private ? this.contracts : this.contracts.filter(c => c.is_public);
  }

  setContracts(contracts) {
    this.contracts = undefined;
    if (contracts) {
      this.contracts = [];
      contracts.forEach((c) => {
        this.contracts.push(c.copy());
      });
    }
  }

  getKinsideId() {
    return this.kinside_id;
  }

  getKinsideFees() {
    return this.kinside_fees;
  }

  // Derived (read only)
  getCenters() {
    return this.centers;
  }
}

module.exports = Provider;
